import { SUPPORTED_LOCALES, type SupportedLocaleType } from '../../locales';
import { ENGLISH_IQ_RESULT_IMG_SCORES } from './english-iq-result-img-scores';

export interface IBuildEnglishIqResultImgArgs {
  locale: SupportedLocaleType;
  score: number;
}

export function buildEnglishIqResultImgR2Key({
  locale,
  score,
}: IBuildEnglishIqResultImgArgs): string {
  if (!Number.isInteger(score) || !ENGLISH_IQ_RESULT_IMG_SCORES.includes(score)) {
    throw new Error(`English IQ result image score invalid: ${score}`);
  }
  if (!(SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    throw new Error(`English IQ result image locale invalid: ${locale}`);
  }
  return `img/english-iq/result-v1/${score}-${locale}.png`;
}
